module.exports = __webpack_public_path__ + "static/media/31-7.d56d3b38.mp3";